<!--
     <ResponsiveMenuDialog>
       <template v-slot:activator={ on }>
         <v-btn v-on="on">CLICK ME</v-btn>
       </template>
       <template v-slot:content>
         My list here ^.^
       </template>
     </ResponsiveMenuDialog>

     Events:
     - @open
     - @close

     Public methods:
     - toggle()
     - open()
     - close()
-->

<template>
  <div>
    <v-menu
      v-if="!is_mobile"
      v-model="menu_open"
      offset-y
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <slot name="activator" :toggle="toggle" :open="open" :close="close">
          <v-btn @click.stop="toggle">Activador</v-btn>
        </slot>
      </template>

      <slot name="content">
        Contenido
      </slot>
    </v-menu>

    <div
      v-else
      class="rmd-mobile"
    >
      <div>
        <slot name="activator" :toggle="toggle" :open="open" :close="close">
          <v-btn @click.stop="toggle">Activador</v-btn>
        </slot>
      </div>
      <div @click="close">
        <v-overlay :value="menu_open" z-index="100"></v-overlay>
      </div>
      <v-slide-y-reverse-transition>
        <div
          v-show="menu_open"
          class="rmd-content"
        >
          <slot name="content">
            Contenido
          </slot>
        </div>
      </v-slide-y-reverse-transition>
    </div>
  </div>
</template>

<style lang="scss">
 .rmd-mobile {
 }

 .rmd-content {
   z-index: 101;
   position: fixed;
   left: 0;
   bottom: 0;
   width: 100vw;
 }
</style>

<script>
 import { mapState, } from 'vuex';
 export default {
   name: "ResponsiveMenuDialog",

   data: () => ({
     menu_open: false,
   }),

   computed: {
    ...mapState(['is_mobile',]),
   },

   methods: {
     toggle() {
       this.menu_open = !this.menu_open;
     },

     close() {
       this.menu_open = false;
     },

     open() {
       this.menu_open = true;
     },
   },

   watch: {
     menu_open(now, before) {
       if (now && !before)
         this.$emit('open');
       else if (!now && before)
         this.$emit('close');
     },
   }
 }
</script>
